import { RootState } from '../../Store';

import { useSelector } from 'react-redux';

const useGetLastResponseCode = (): number => {
    return useSelector<RootState, number>(state => state.app.lastResponseCode);
};

export default useGetLastResponseCode;
